export const GET_OVERVIEW = 'parcel/overview/GET_OVERVIEW';
export const GET_OVERVIEW_SUCCESS = 'parcel/overview/GET_OVERVIEW_SUCCESS';
export const GET_OVERVIEW_ERROR = 'parcel/overview/GET_OVERVIEW_ERROR';
